import { FormLabel, FormHelperText, FormControl } from "@mui/material";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Textarea from "@mui/joy/Textarea";

const FormTextArea = ({
  defaultValue,
  disabled = false,
  error = false,
  formLabel,
  formTextHelper,
  maxLength = 150,
  maxRows = 10,
  minRows = 3,
  name,
  onBlur,
  onChange,
  placeholder,
  required = false,
  size = "md",
  textAreaClasses = "Outlined-Input",
  textAreaType = "outlined",
  value,
}) => {
  const [localValue, setLocalValue] = useState(value || defaultValue || "");
  const textareaRef = useRef(null);

  useLayoutEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    // Manually resize without triggering ResizeObserver loop
    const lineHeight = 24;
    const padding = 16;
    const minHeight = minRows * lineHeight + padding;
    const maxHeight = maxRows * lineHeight + padding;

    el.style.height = "auto";
    el.style.height = `${Math.min(
      Math.max(el.scrollHeight, minHeight),
      maxHeight,
    )}px`;
    el.style.overflow = el.scrollHeight > maxHeight ? "auto" : "hidden";
  }, [value, minRows, maxRows]);

  const handleBlur = (event) => {
    onBlur?.(event.target.value, event);
  };

  const handleChange = (event) => {
    setLocalValue(event.target.value);
    onChange?.(event.target.value, event);
  };

  useEffect(() => {
    let els = document.querySelectorAll(".form-text-area label ");
    let width;
    if (els) {
      //for now, just use the first el to set all widths
      //in the future: make dynamic in case there are multiple FormTextAreas with different labels
      width = els[0].offsetWidth + 2;
    }
    let backgroundEls = document.querySelectorAll(".label-background");
    if (backgroundEls && els) {
      //set the width for each background element, so the outline is blocked from view behind the label
      backgroundEls.forEach((backgroundEl) => {
        backgroundEl.style.width = `${width}px`;
      });
    }
  }, [formLabel]);

  useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  return (
    <FormControl className="w-100 form-text-area" error={error}>
      {formLabel && <FormLabel>{formLabel}</FormLabel>}
      <div className="label-background" />
      <Textarea
        className={textAreaClasses}
        defaultValue={defaultValue}
        disabled={disabled}
        error={error}
        name={name}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        size={size}
        sx={{
          width: "99%",
          // Fix the height manually, disable Joy UI's internal auto-resize
          "& textarea": { overflow: "hidden", resize: "none" },
        }}
        slotProps={{
          textarea: { ref: textareaRef, maxLength },
        }}
        value={value}
        variant={textAreaType}
      />
      {formTextHelper && <FormHelperText>{formTextHelper}</FormHelperText>}
      {maxLength && (
        <FormHelperText className="Row" sx={{ justifyContent: "flex-end" }}>
          {localValue?.length || 0}/{maxLength}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FormTextArea;
